const DOMAIN = process.env.REACT_APP_SHOPIFY_STORE_DOMAIN;
const TOKEN = process.env.REACT_APP_SHOPIFY_STOREFRONT_TOKEN;
const API_URL = `https://${DOMAIN}/api/2026-01/graphql.json`;

async function shopifyFetch(query, variables = {}) {
  const res = await fetch(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": TOKEN,
    },
    body: JSON.stringify({ query, variables }),
  });
  const json = await res.json();
  if (json.errors) throw new Error(json.errors[0].message);
  return json.data;
}

const CART_FIELDS = `
  fragment CartFields on Cart {
    id
    checkoutUrl
    totalQuantity
    cost { subtotalAmount { amount currencyCode } }
    lines(first: 25) {
      edges {
        node {
          id
          quantity
          merchandise {
            ... on ProductVariant {
              id
              image { url }
              product { title handle }
              price { amount currencyCode }
            }
          }
        }
      }
    }
  }
`;

export function fetchProducts() {
  return shopifyFetch(`{
    products(first: 10) {
      edges { node { title handle variants(first: 1) { edges { node { id price { amount currencyCode } } } } } }
    }
  }`);
}

export function fetchCart(id) {
  return shopifyFetch(
    `${CART_FIELDS} query GetCart($id: ID!) { cart(id: $id) { ...CartFields } }`,
    { id }
  );
}

export function cartCreate(lines) {
  return shopifyFetch(
    `${CART_FIELDS} mutation CartCreate($lines: [CartLineInput!]!) {
      cartCreate(input: { lines: $lines }) { cart { ...CartFields } userErrors { message } }
    }`,
    { lines }
  );
}

export function cartLinesAdd(cartId, lines) {
  return shopifyFetch(
    `${CART_FIELDS} mutation LinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
      cartLinesAdd(cartId: $cartId, lines: $lines) { cart { ...CartFields } userErrors { message } }
    }`,
    { cartId, lines }
  );
}

export function cartLinesUpdate(cartId, lines) {
  return shopifyFetch(
    `${CART_FIELDS} mutation LinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
      cartLinesUpdate(cartId: $cartId, lines: $lines) { cart { ...CartFields } userErrors { message } }
    }`,
    { cartId, lines }
  );
}

export function cartLinesRemove(cartId, lineIds) {
  return shopifyFetch(
    `${CART_FIELDS} mutation LinesRemove($cartId: ID!, $lineIds: [ID!]!) {
      cartLinesRemove(cartId: $cartId, lineIds: $lineIds) { cart { ...CartFields } userErrors { message } }
    }`,
    { cartId, lineIds }
  );
}
